/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the UnknownGradeListItem component that is displayed at the top of each
 * view.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

/**
 * Utility used to generate a Hook to allow for the creation of styles using JSS.
 */
import { makeStyles } from '@material-ui/core/styles';

/**
 * Material UI ListItem component.
 */
import ListItem from '@material-ui/core/ListItem';

/**
 * Material UI ListItemIcon component.
 */
import ListItemIcon from '@material-ui/core/ListItemIcon';

/**
 * Material UI ListItemText component.
 */
import ListItemText from '@material-ui/core/ListItemText';

/**
 * Material UI Fade component.
 */
import Fade from '@material-ui/core/Fade';

/**
 * Material UI Divider component.
 */
import Divider from '@material-ui/core/Divider';

/**
 * Used to display SVG icons.
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

/**
 * SVG icon definition
 */
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';

/**
 * used to navigate around the app.
 */
import { Link } from 'react-router-dom';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Typings
 */
import * as Dtos from '../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces / Types
 * ---------------------------------------------------------------------------------
 */

interface IUnknownGradeListItemProps {
    version: Dtos.Version;
    category: Dtos.Category;
    term: Dtos.Term;
    subterm: Dtos.Term | null;
    showDivider?: boolean;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles(theme => ({
    listItem: {
    },
    iconGradeUnknown: {
        color: theme.palette.primary.main,
        opacity: 1
    }
}));

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

const UnknownGradeListItem: React.FunctionComponent<IUnknownGradeListItemProps> = ({
    version,
    term,
    subterm,
    showDivider
}) => {
    // Get classnames for styles.
    const classes = useStyles();

    // const gradeLoadState = useGradeSelector(state => GradeSelectors.selectGradeLoadState(state, gradeId));

    return (
        <Fade
            in={true}
        >
            <div>
                <ListItem
                    button
                    className={classes.listItem}
                    component={Link}
                    to={`/${version.code}/browse/term/${subterm ? subterm.id : term.id}/unknown`}
                >
                    <ListItemIcon>
                        <FontAwesomeIcon
                            fixedWidth
                            icon={faUser}
                            className={classes.iconGradeUnknown}
                            size="lg"
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary="Unknown Grade"
                        secondary="The exact grade of the event is not known"
                    />
                </ListItem>
                {
                    showDivider && (
                        <Divider />
                    )
                }
            </div>
        </Fade>
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Export - Default
 * ---------------------------------------------------------------------------------
 */

export default UnknownGradeListItem;


// WEBPACK FOOTER //
// ./src/components/UnknownGradeListItem.tsx